import { render, staticRenderFns } from "./CategoryProfile.vue?vue&type=template&id=94f93d1e"
import script from "./CategoryProfile.vue?vue&type=script&lang=js"
export * from "./CategoryProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports